// extracted by mini-css-extract-plugin
export default {"businessContainer":"Business_businessContainer__lAgBa","tab":"Business_tab__Iw5Wh"};